'use strict';
var call = Function.prototype.call;

module.exports = call.bind.bind(call, call);
